var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535768",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m4.595-17.433c.635.594 1.476 1.04 2.405 1.067l-.009 2.424c-1.278-.023-2.475-.35-3.477-1.043v5.36a4.757 4.757 0 1 1-4.756-4.757q.356-.001.703.074v2.63a2.173 2.173 0 0 0-2.821 2.634 2.176 2.176 0 0 0 2.118 1.59c1.198 0 2.174-.959 2.174-2.586V4h2.585a3.48 3.48 0 0 0 1.078 2.567",
    clipRule: "evenodd"
  })));
};
export default SvgTiktok;